module.exports = __webpack_public_path__ + "img/Phone-2-p-500.f9a33467.png";